import React, { useEffect, useState } from "react";
import Footer from "../Fotter";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteCartItem, viewCartData } from "../redux/slices/ViewCartSlice";
import { CustomeStyle } from "../Css/CustomeStyle";
import CustomBox from "../utli/CustomBox";
import { ConfirmOrder } from "../redux/slices/ConfirmOrderSlice";
import endPoint from "../redux/EndPoint/endpoint";
import axios from "axios";

const Cart = () => {
  const navigate = useNavigate();
  const { ViewCart } = useSelector((state) => state.viewCart);
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [itemId, setItemId] = useState(null);
  const [shippingCost, setShippingCost] = useState(null);
  const [isLoginModalVisible, setIsLoginModalVisible] = useState(false);

  const isResellerCart = ViewCart?.cartItems?.some(
    (item) => item?.isResellerProduct === true
  );

  useEffect(() => {
    const handlePageShow = (event) => {
      localStorage.removeItem("checkoutData");
      localStorage.removeItem("addressId");
      dispatch(viewCartData());
    };

    // Initial load pe bhi clear karo
    localStorage.removeItem("checkoutData");
    localStorage.removeItem("addressId");
    dispatch(viewCartData());

    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(viewCartData());
  }, [dispatch]);

  const increaseQuantity = async (item) => {
    try {
      const storedUuid = localStorage.getItem("uuid");
      const Token = localStorage.getItem("authToken");
      if (Token) {
        const response = await axios.put(
          `${endPoint.UPDATECART}/${item?._id}`,
          {
            quantity: item?.quantity + 1,
          },
          {
            headers: {
              Authorization: Token ? `Bearer ${Token}` : "",
            },
          },
        );
        dispatch(viewCartData());
        return response.data;
      } else {
        const response = await axios.put(
          `${endPoint.UPDATECART}/${item?._id}`,
          {
            sessionId: storedUuid ? storedUuid : "",
            quantity: item?.quantity + 1,
          },
        );
        dispatch(viewCartData());
        return response.data;
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const decreaseQuantity = async (item) => {
    try {
      const Token = localStorage.getItem("authToken");
      const storedUuid = localStorage.getItem("uuid");

      if (item?.quantity - 1 === 0) {
        dispatch(deleteCartItem(item?.productId));
      }
      if (Token) {
        const response = await axios.put(
          `${endPoint.UPDATECART}/${item?._id}`,
          {
            quantity: item?.quantity - 1,
          },
          {
            headers: {
              Authorization: Token ? `Bearer ${Token}` : "",
            },
          },
        );
        dispatch(viewCartData());
        return response.data;
      } else {
        const response = await axios.put(
          `${endPoint.UPDATECART}/${item?._id}`,
          {
            sessionId: storedUuid ? storedUuid : "",
            quantity: item?.quantity - 1,
          },
        );
        dispatch(viewCartData());
        return response.data;
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const handleRemoveFromCart = (id) => {
    setItemId(id);
    setShowModal(true);
  };

  const handleConfirmRemove = () => {
    dispatch(deleteCartItem(itemId));
    setShowModal(false);
  };

  const handleCloseBox = () => {
    setShowModal(false);
  };

  const _handleClick = () => {
    navigate("/");
  };

  const _handleCheckout = () => {
    dispatch(ConfirmOrder())
      .unwrap()
      .then((response) => {
        const token = localStorage.getItem("authToken");

        if (token) {
          navigate("/Address");
        } else {
          setIsLoginModalVisible(true);
        }
      })
      .catch((error) => {
        console.error("Error placing order:", error);
        alert("Failed to place order. Please try again.");
      });
  };

  useEffect(() => {
    const fetchShippingCost = async () => {
      try {
        const response = await axios.get(
          "https://www.bharatcod.com/admin/getDeliveryCost",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          },
        );

        const cost = response.data.deliveryCost.shippingCost;
        setShippingCost(cost);
      } catch (error) {
        console.error("Error fetching shipping cost:", error);
      }
    };

    fetchShippingCost();
  }, []);

  const handleLoginRedirect = () => {
    navigate("/my-account");
    setIsLoginModalVisible(false);
  };

  const handleCloseModal = () => {
    setIsLoginModalVisible(false);
  };

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-16647750621";
    script1.async = true;
    document.head.appendChild(script1);

    script1.onload = () => {
      const script2 = document.createElement("script");
      script2.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-16647750621');
        `;
      document.head.appendChild(script2);
    };

    return () => {
      const scripts = document.querySelectorAll(
        'script[src="https://www.googletagmanager.com/gtag/js?id=AW-16647750621"]',
      );
      scripts.forEach((script) => script.remove());
    };
  }, []);

  const TotalPriceCart = ViewCart?.cartItems
    ? (
      ViewCart?.cartItems.reduce(
        (acc, item) => acc + (item.totalPrice || 0),
        0,
      ) + (shippingCost || 0)
    ).toFixed(2)
    : "Loading...";

  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-16647750621/zBwdCKHYjcEaEN2HooI-",
        value: TotalPriceCart,
        currency: "INR",
        transaction_id: "",
      });
    }
  }, []);

  return (
    <div cclassName="min-h-screen flex flex-col pb-20">
      <div className="flex-grow">
        <div className=" mx-auto px-4 sm:px-6 lg:px-8">
          {ViewCart?.cartItems?.length > 0 ? (
            <div className="bg-white p-4 sm:p-6 rounded-lg">
              <h3 className="font-bold text-lg sm:text-xl mb-4 sm:mb-6">
                Cart Items
              </h3>
              {ViewCart?.cartItems?.map((item) => {
                return (
                  <div
                    key={item._id}
                    className="flex flex-wrap sm:flex-nowrap items-start gap-4 sm:gap-6 sm:mb-6 border-b pb-4 sm:pb-6"
                  >
                    <img
                      src={item?.images[0]}
                      alt={item?.title}
                      className="w-20 h-20 sm:w-24 sm:h-24 object-cover rounded-lg flex-shrink-0"
                    />

                    <div className="flex-1 flex flex-col justify-between">
                      <div className="flex flex-col">
                        <h4 className="text-base sm:text-lg font-semibold text-gray-800 line-clamp-1">
                          {item?.title}
                        </h4>

                        <div className="flex items-center gap-2">
                          <span className="text-lg font-semibold text-black">
                            Price :-
                          </span>
                          <span className="text-lg font-semibold text-black">
                            ₹{item?.price}
                          </span>
                          <span className="text-sm line-through text-gray-500">
                            ₹{item?.regularPrice}
                          </span>
                        </div>
                        {item?.appliedCoupon && (
                          <>
                            <div className="flex items-center gap-2">
                              <span className="text-lg font-semibold text-black">
                                Applied Coupon Code :-
                              </span>
                              <span className="text-lg font-semibold text-black">
                                {item?.appliedCoupon?.couponCode}
                              </span>
                            </div>
                            <div className=" text-lg  text-gray-600">
                              <span className="text-lg font-semibold text-black">
                                Discount :-{" "}
                              </span>
                              <span className="text-black font-semibold ms-2">
                                {item?.appliedCoupon?.discountType == "fixed" &&
                                  "₹"}
                                {item?.appliedCoupon?.discountValue}{" "}
                                {item?.appliedCoupon?.discountType == "fixed"
                                  ? ""
                                  : "%"}
                              </span>
                            </div>
                            <div className="flex items-center gap-2">
                              <span className="text-lg font-semibold text-black">
                                Discount Price :-
                              </span>
                              <span className="text-lg font-semibold text-black">
                                ₹{item?.finalPrice}
                              </span>
                              <span className="text-xs line-through text-gray-500">
                                ₹{item?.totalBeforeCoupon}
                              </span>
                            </div>
                          </>
                        )}
                        <div className="text-sm text-gray-600 flex  flex-wrap  mb-2">
                          {item.size && (
                            <span className="text-lg  text-black">
                              Size: {item.size}
                            </span>
                          )}
                          {item.color && (
                            <span className="text-xs line-through text-gray-500">
                              Color: {item.color}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="flex items-center gap-4 mt-1 sm:mt-2">
                        <button
                          className="h-8 w-8 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition duration-200"
                          onClick={() => decreaseQuantity(item)}
                        >
                          -
                        </button>
                        <span className="text-lg font-semibold text-gray-800">
                          {item.quantity}
                        </span>
                        <button
                          className="h-8 w-8 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition duration-200"
                          onClick={() => increaseQuantity(item)}
                        >
                          +
                        </button>
                      </div>
                    </div>

                    <div className="w-full sm:w-auto mt-1 sm:mt-0">
                      <button
                        className="w-full sm:w-auto bg-gray-200 border border-gray-400 text-gray-600 px-4 py-2 rounded hover:bg-gray-400 hover:text-white transition"
                        onClick={() => handleRemoveFromCart(item?._id)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                );
              })}

              <div className="bg-slate-100 p-5 rounded-lg mb-6 border border-gray-200">
                <h3 className="font-semibold text-2xl sm:text-3xl text-gray-800 mb-4 text-center">
                  Price Details
                </h3>
                <div className="flex justify-between text-lg mt-3 text-gray-600">
                  <span>Shipping Charges</span>
                  <span className="text-black font-semibold">
                    ₹ {shippingCost !== null ? shippingCost : "Loading..."}
                  </span>
                </div>
                <div className="flex justify-between text-xl sm:text-2xl font-semibold mt-5 text-gray-800">
                  <span>Total Amount</span>
                  <span className="text-xl text-green-600">
                    ₹{" "}
                    {ViewCart?.cartItems
                      ? (
                        ViewCart?.cartItems.reduce(
                          (acc, item) => acc + (item.totalPrice || 0),
                          0,
                        ) + (shippingCost || 0)
                      ).toFixed(2)
                      : "Loading..."}
                  </span>
                </div>
              </div>

              <div className="text-center mb-5">
                <button
                  onClick={_handleCheckout}
                  className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded font-semibold w-64 sm:w-80"
                >
                  Proceed to Checkout
                </button>

                {isLoginModalVisible && (
                  <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-96 relative">
                      <button
                        onClick={handleCloseModal}
                        className="absolute top-2 right-2 text-gray-600 text-xl"
                      >
                        ❌
                      </button>
                      <h3 className="text-2xl font-semibold mb-4 text-center">
                        Please Login
                      </h3>
                      <p className="text-gray-600 mb-6 text-center">
                        You need to log in to proceed with the checkout process.
                      </p>
                      <div className="flex justify-center">
                        <button
                          onClick={handleLoginRedirect}
                          className="bg-blue-500 text-white px-6 py-3 rounded-lg text-xl w-48"
                        >
                          Login
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <>
              <div className="flex justify-center items-start mt-[10%]">
                <h1 className={`${CustomeStyle.headerText} text-center`}>
                  Cart
                </h1>
              </div>{" "}
              <div className="flex items-center justify-center mt-[5%] w-full h-[200px]">
                <div className="bg-gradient-to-r from-yellow-200 via-yellow-100 to-yellow-100 h-48 w-[90%] border-gray-300 rounded-lg shadow-lg flex items-center justify-center mx-auto">
                  <p className="text-black text-lg font-semibold">
                    Your cart is currently empty.
                  </p>
                </div>
              </div>
              <button
                onClick={() => _handleClick()}
                className="mb-5 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition duration-300 flex justify-center items-center mx-auto mt-10"
              >
                Return to Shop
              </button>
            </>
          )}
        </div>
        <CustomBox
          show={showModal}
          message="Are you sure you want to remove this item from your cart?"
          onCancel={handleCloseBox}
          onConfirm={handleConfirmRemove}
        />
      </div>
      {!isResellerCart && <Footer />}
    </div>
  );
};

export default Cart;
